var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercardCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.14062V18.5406C22 18.872 21.7314 19.1406 21.4 19.1406H2.6C2.26863 19.1406 2 18.872 2 18.5406V5.74063C2 5.40925 2.26863 5.14062 2.6 5.14062H21.4C21.7314 5.14062 22 5.40925 22 5.74062V9.14062ZM22 9.14062H6",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.5226C16.7654 13.2851 17.1158 13.1406 17.5 13.1406C18.3284 13.1406 19 13.8122 19 14.6406C19 15.4691 18.3284 16.1406 17.5 16.1406C17.1158 16.1406 16.7654 15.9962 16.5 15.7587",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.5226C16.2346 13.2851 15.8842 13.1406 15.5 13.1406C14.6716 13.1406 14 13.8122 14 14.6406C14 15.4691 14.6716 16.1406 15.5 16.1406C15.8842 16.1406 16.2346 15.9962 16.5 15.7587",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardCard);
export default __webpack_public_path__ + "static/media/mastercard-card.f756185245fb31b28cbf3c9761c40a3f.svg";
export { ForwardRef as ReactComponent };